import Vue from "vue";
import App from "./App.vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "animate.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "./assets/css/global.css";
import "@fortawesome/fontawesome-free/css/all.css";
import i18n from "./lang/i18n";
import { applyColorTheme, loadThemeFromStorage } from "./utils/colors";
import VueMeta from "vue-meta";
import router from './router' // 导入路由

Vue.use(ElementUI);
Vue.use(VueMeta);

Vue.config.productionTip = false;

loadThemeFromStorage() || applyColorTheme();

// ✅ 设置默认语言（来自 index.html）
if (window.defaultLang) {
  i18n.locale = window.defaultLang;
}

const app = new Vue({
  i18n,
  router,
  render: (h) => h(App),
  mounted() {
    // 初始化动画
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });

    // ✅ 初始化时设置标题
    document.title = this.$t("pageTitle");
  },
  watch: {
    // ✅ 监听语言变化自动修改标题
    "$i18n.locale"(newLang) {
      document.title = this.$t("pageTitle");
    },
  },
}).$mount("#app");
